export var ChatThemeType;
(function (ChatThemeType) {
    ChatThemeType["LIGHT"] = "light";
    ChatThemeType["DARK"] = "dark";
    ChatThemeType["CHATTHEMEA"] = "chatThemeA";
    ChatThemeType["CHATTHEMEB"] = "chatThemeB";
    ChatThemeType["CHATTHEMEC"] = "chatThemeC";
    ChatThemeType["CHATTHEMED"] = "chatThemeD";
    ChatThemeType["CHATTHEMEE"] = "chatThemeE";
    ChatThemeType["CHATTHEMEF"] = "chatThemeF";
    ChatThemeType["CHATTHEMEG"] = "chatThemeG";
})(ChatThemeType || (ChatThemeType = {}));
